import React, {Component} from 'react';
import marketStyle from '../css/marketsSoccer3.css';
import OddsCardSoccer3 from './oddsCardSoccer3';

class WinDrawWinSoccer3 extends Component {

    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        let selectedEvent = this.props.selectedEvent;
        markets[0].selection = selectedEvent.teamOne;
        markets[2].selection = selectedEvent.teamTwo;

        return (<div className={marketStyle.marketGroup}>
            <div className={marketStyle.scoreGroupSmall}>
                <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                    <span>1</span>
                </div>
                <div className={marketStyle.oddsContainerSmall}>
                    <OddsCardSoccer3 store={store} market={markets[0]}/>
                </div>
            </div>
            <div className={marketStyle.scoreGroupSmall}>
                <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                    <span>X</span>
                </div>
                <div className={marketStyle.oddsContainerSmall}>
                    <OddsCardSoccer3 store={store} market={markets[1]}/>
                </div>
            </div>
            <div className={marketStyle.scoreGroupSmall}>
                <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                    <span>2</span>
                </div>
                <div className={marketStyle.oddsContainerSmall}>
                    <OddsCardSoccer3 store={store} market={markets[2]}/>
                </div>
            </div>
        </div>);
    }
}

export default WinDrawWinSoccer3;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/winDrawWinSoccer3.js